<script setup>
import { toRef } from 'vue';
import { CsButton, CsIcon, CsText } from 'dashboard/components/ui/commslayer';
import { useAvailability } from 'widget/composables/useAvailability';
import { useDarkMode } from 'widget/composables/useDarkMode';
import { useRouter } from 'widget/composables/route';

const props = defineProps({
  avatarUrl: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  showPopoutButton: {
    type: Boolean,
    default: false,
  },
  showBackButton: {
    type: Boolean,
    default: false,
  },
  availableAgents: {
    type: Array,
    default: () => [],
  },
});

const router = useRouter();
const { $dm } = useDarkMode();

const { replyWaitMessage } = useAvailability({
  availableAgents: toRef(props, 'availableAgents'),
});

const onBackButtonClick = () => {
  router.replace({ name: 'home' });
};
</script>

<template>
  <header
    class="flex items-center gap-1 justify-between py-4 shadow-sm px-2.5 w-full"
    :class="$dm('bg-white', 'dark:bg-slate-900')"
  >
    <div class="flex items-center gap-2">
      <CsButton
        v-if="showBackButton"
        variant="tertiary"
        is-icon-only
        @click="onBackButtonClick"
      >
        <CsIcon name="chevron-left" class="h-6 w-6" />
      </CsButton>
      <div class="flex items-center gap-2">
        <img
          v-if="avatarUrl"
          class="h-10 w-10 rounded-full object-cover"
          :src="avatarUrl"
          alt="avatar"
        />
        <div>
          <CsText weight="semibold">
            <span v-dompurify-html="title" />
          </CsText>
          <CsText variant="body-sm" variant-color="secondary">
            {{ replyWaitMessage }}
          </CsText>
        </div>
      </div>
    </div>
  </header>
</template>
